import { supabase } from "./supabase";

export async function uploadImageToBucket(file: File, folder: string = "blog") {
  const ext = file.name.split(".").pop();
  const path = `${folder}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;

  const { data, error } = await supabase.storage
    .from("blog-images")
    .upload(path, file);

  if (error) {
    console.error("Upload error:", error);
    throw error;
  }

  const { data: publicData } = supabase.storage
    .from("blog-images")
    .getPublicUrl(path);

  return publicData.publicUrl; // ✅ final URL to save in DB or paste in content
}
